/**
 * CRITICAL: This module MUST be imported BEFORE any module that
 * initializes the Supabase client (which has detectSessionInUrl: true).
 *
 * The main Supabase client auto-parses URL hash tokens on init,
 * consuming them before reset-password.tsx can read them.
 * This module captures the hash into sessionStorage so the
 * recovery flow can retrieve tokens later.
 *
 * Import order in main.tsx matters:
 *   import "./recovery-hash-capture";  ← runs first (no deps)
 *   import { App } from "./App";       ← runs second (inits supabase)
 */
(() => {
  const hash = window.location.hash;
  if (hash && hash.includes("type=recovery")) {
    sessionStorage.setItem("supabase-recovery-hash", hash.substring(1));
  }
})();
